import { render, staticRenderFns } from "./ScreenBuilder.vue?vue&type=template&id=9f2843fc&lang=pug&"
import script from "./ScreenBuilder.vue?vue&type=script&lang=js&"
export * from "./ScreenBuilder.vue?vue&type=script&lang=js&"
import style0 from "./ScreenBuilder.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports